module.exports = __webpack_public_path__ + "img/todayPerson.447316f4.png";